<template>
  <div id="app">

    <div class=' mb-5'>
      <!-- <pre>{{user}}</pre> -->
      <!-- Just an image -->
      <b-navbar class='navbar px-1 px-sm-5' variant="faded" type="dark" toggleable="md">
        <div class="container">
          <b-navbar-brand href="/">
            <img class='d-none d-sm-inline' id="logo" src="./assets/largada-esportiva-horizontal-negative.svg"
              alt="Largada Esportiva">
            <img class='d-inline d-sm-none' id="logo-small"
              src="./assets/largada-esportiva-horizontal-negative-small.svg" alt="Largada Esportiva">
          </b-navbar-brand>

          <b-navbar-nav class="ml-auto">
            <b-navbar-toggle target="nav_dropdown_collapse"></b-navbar-toggle>

            <b-collapse is-nav id="nav_dropdown_collapse">
              <div class="">
                <div class="col-12 tr fs6">
                  <b-nav-text href="#" v-if="user && user.name"> Olá {{ username }} <a class='hover' @click="singout">
                      <ico icon='sign-out-alt'></ico>
                    </a> </b-nav-text>
                  <b-nav-item href="/login" v-else> Logar </b-nav-item>
                </div>
                <div class="col-12 tr">
                  <b-navbar-nav>
                    <b-nav-item href="/"><b>Inscreva-se</b></b-nav-item>
                    <b-nav-item href="/myregistrations"><b>Minhas Inscrições</b></b-nav-item>
                    <b-nav-item v-if="user._admin" href="/admin/registrations/"><b>Todas Inscrições</b></b-nav-item>
                    <b-nav-item href="/contato"><b>Contato</b></b-nav-item>
                    <b-nav-item v-if="user._admin" href="/admin/events"><b>Admin</b></b-nav-item>
                  </b-navbar-nav>
                </div>
              </div>

            </b-collapse>
          </b-navbar-nav>
        </div>
      </b-navbar>
    </div>

    <div style="min-height:100vh">
      <router-view />
    </div>

    <!-- <h1>Em Manutenção. Voltamos em instantes </h1> -->

    <div>
      <small>
        <!-- <router-link to="/admin/events"> Administrar </router-link> -->
      </small>
    </div>


  </div>
</template>

<script>
export default {
  data(){
    return {initialize:false}
  },
  computed:{
        user:function(){
            return this.$store.getters.user
        },
        username:function(){
          if( this.user.name )
             return this.user.name.split(' ')[0] 
          return ""
        }
    },

    methods:{
      singout:function(){
          this.$store.dispatch('logout');
          this.$router.push("/")
      }
    }
}


</script>
<style lang="stylus" scoped>
#app
  font-family 'Avenir', Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  text-align left
  color #2c3e50
.navbar
  background:rgba(#2c3e50,1)
  padding 1rem 0.5rem
#logo
  min-width 230px;
#logo-small
  min-width 160px;
</style>
